export const REQUEST_LOGIN = 'REQUEST_LOGIN';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const MERCHANT_SELECTED = 'MERCHANT_SELECTED';
export const LOGOUT = 'LOGOUT';
export const ERROR = 'ERROR';